import { requireService, wrap } from '@repo/di-ez';
import { TableCell } from '@repo/go-table';
import type { GridColDef, GridRenderCellParams } from '@repo/go-table';
import type { CSSProperties, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import type { FactTrajectoryPointEntity } from '../../../service/entities';
import { isTrajectoryEditableField } from '../editable-fields';

const EMPTY_DISPLAY = '—';

const CELL_JUSTIFY_CONTENT_BY_ALIGN: Record<NonNullable<GridColDef['align']>, CSSProperties['justifyContent']> = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
};

type Props = {
  params: GridRenderCellParams<FactTrajectoryPointEntity>;
  children?: ReactNode;
};

export const TrajectoryTableCell = wrap<Props>(function TrajectoryTableCell({ params, children }) {
  const { t } = useTranslation();
  const validationStore = requireService('trajectoryTableValidationStore');

  const error = isTrajectoryEditableField(params.field)
    ? validationStore.getFieldError(params.row.entityId, params.field)
    : null;

  const justifyContent = params.colDef.align ? CELL_JUSTIFY_CONTENT_BY_ALIGN[params.colDef.align] : undefined;

  return (
    <TableCell
      message={error ? t(`Table.validation.${error}`) : undefined}
      style={{
        backgroundColor: error ? 'var(--go-table-cell-error-bg-color)' : undefined,
        justifyContent,
      }}
    >
      {children ?? params.formattedValue ?? params.value ?? EMPTY_DISPLAY}
    </TableCell>
  );
});
